import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaRupeeSign } from 'react-icons/fa';

const SpaceCard = ({ space }) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition">
      <div className="h-48 bg-gray-300 relative">
        {space.images && space.images[0] ? (
          <img src={space.images[0]} alt={space.title} className="w-full h-full object-cover" />
        ) : (
          <div className="flex items-center justify-center h-full text-gray-500">No Image</div>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-xl font-semibold mb-2">{space.title}</h3>
        <p className="text-gray-600 text-sm mb-3 line-clamp-2">{space.description}</p>
        <div className="flex items-center text-gray-700 mb-2">
          <FaMapMarkerAlt className="mr-2" />
          <span className="text-sm">{space.location.city}</span>
        </div>
        <div className="flex items-center justify-between">
          <div style={{ color: '#003d66' }} className="flex items-center font-bold text-lg">
            <FaRupeeSign />
            <span>{space.pricePerMonth.toLocaleString()}/month</span>
          </div>
          <Link to={`/spaces/${space._id}`} style={{ backgroundColor: '#2563eb' }} className="text-white px-4 py-2 rounded transition hover:opacity-90">
            View Details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SpaceCard;
